'use client'

import Image from 'next/image'
import { useState } from 'react'

import { ImageType } from '@/lib/models/components/image.types'
import { VideoPlayer } from '@/modules/career/components/VideoPlayer.component'

interface VideoWithThumbnailProps {
  url?: string
  caption?: string
  thumbnail?: ImageType
  thumbnailMobile?: ImageType
  apiAssetsUrl: string | undefined
}

export const VideoWithThumbnail = ({
  url,
  caption,
  thumbnail,
  thumbnailMobile,
  apiAssetsUrl,
}: VideoWithThumbnailProps) => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false)

  return (
    <div>
      <div
        className={`group relative ${
          url && !isVideoPlaying && 'cursor-pointer'
        }`}
        onClick={() => setIsVideoPlaying(true)}
      >
        {url && isVideoPlaying && (
          <div className="relative flex items-center justify-center">
            <VideoPlayer url={url} />
          </div>
        )}
        {thumbnail?.url && !isVideoPlaying && (
          <Image
            className="hidden h-[600px] w-full rounded-lg object-cover object-center lg:block"
            src={`${apiAssetsUrl || ''}${thumbnail.url}`}
            width={thumbnail.width}
            height={thumbnail.height}
            alt={thumbnail.alternativeText || 'Careers image'}
          />
        )}
        {thumbnailMobile?.url && !isVideoPlaying && (
          <Image
            className="aspect-video w-full object-cover object-center lg:hidden"
            src={`${apiAssetsUrl || ''}${thumbnailMobile.url}`}
            width={thumbnailMobile.width}
            height={thumbnailMobile.height}
            alt={thumbnailMobile.alternativeText || 'Careers image'}
          />
        )}
        {url && !isVideoPlaying && (
          <Image
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform transition-all duration-200 ease-in-out group-hover:scale-110 group-active:scale-90 group-active:duration-100"
            src="/play-button.svg"
            width="120"
            height="120"
            alt="Play button"
          />
        )}
      </div>
      {url && caption && (
        <div className="caption px-6 pt-4 xl:px-10">{caption}</div>
      )}
    </div>
  )
}
